import PrivacyPolicyComponent from "../../../../components/partner/Settings/privacy-policy/privacy-policy";

export default function PrivacyPolicy() {
  return <PrivacyPolicyComponent />;
}
